import client from './client';

export default (function ChapterService() {
  let service;

  if (!service) {
    service = client.service('chapters');
  }

  return service;
}());
